<template>
    <div class="home-container">
        <div class="logo-container">
            <!-- 使用 require 引入图片 -->
            <img :src="logoUrl" width="450" alt="Logo">
        </div>
        <h2 class="welcome-text" v-html="welcomeText"></h2>
    </div>
</template>

<script setup>
// 使用 require 引入静态资源
const logoUrl = new URL('@/assets/image/gshnbst_logo.png', import.meta.url).href

const welcomeText = '大家好，欢迎访问快乐天使阿杜，网站还在搭建中，如有问题，欢迎联系作者，<br>作者微信：gshnbst,感谢大家的支持！！！'
</script>

<style scoped>
.home-container {
    text-align: center;
    padding: 20px;
}

.logo-container {
    margin-bottom: 20px;
}

.welcome-text {
    margin: 20px 0;
}
</style>